/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S5_Li2Inputs */

const tr_onbilgi_s5_li2 = /** @type {(inputs: Onbilgi_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonelik süresi 1 ay veya 1 yıl olarak belirlenir; seçim abonelik tamamlama anında yapılır.`)
};

const en_onbilgi_s5_li2 = /** @type {(inputs: Onbilgi_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The subscription term is set as 1 month or 1 year; the choice is made at the moment the subscription is completed.`)
};

const de_onbilgi_s5_li2 = /** @type {(inputs: Onbilgi_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Abonnementdauer wird auf 1 Monat oder 1 Jahr festgelegt; die Wahl erfolgt im Moment des Abonnementabschlusses.`)
};

const ru_onbilgi_s5_li2 = /** @type {(inputs: Onbilgi_S5_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Срок подписки составляет 1 месяц или 1 год; выбор осуществляется в момент оформления подписки.`)
};

/**
* | output |
* | --- |
* | "The subscription term is set as 1 month or 1 year; the choice is made at the moment the subscription is completed." |
*
* @param {Onbilgi_S5_Li2Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s5_li2 = /** @type {((inputs?: Onbilgi_S5_Li2Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S5_Li2Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s5_li2(inputs)
	if (locale === "de") return de_onbilgi_s5_li2(inputs)
	if (locale === "ru") return ru_onbilgi_s5_li2(inputs)
	return tr_onbilgi_s5_li2(inputs)
});